import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
} from '@angular/core';
import { isNotNullOrUndefined } from '@pcp/core/util';
import { distinctUntilChanged, map, Observable, take } from 'rxjs';
import {
    DIFFICULT_QUESTION_ELEMENT_BASE_URL,
    DIFFICULT_QUESTION_ELEMENT_ENET_TOKEN,
    DIFFICULT_QUESTION_ELEMENT_IS_MAIN_CLIENT,
    DIFFICULT_QUESTION_ELEMENT_LANGUAGE_CODE,
    DIFFICULT_QUESTION_ELEMENT_MUTE_AUDIO, ENVIRONMENT_TYPE,
    VOTING_ELEMENT_BASE_URL
} from './injection-tokens';
import { QuestionModuleType } from "@pcp/core/interfaces";
import { AsyncPipe } from '@angular/common';
import { EmmIframeComponent } from 'shared/classroom/preview-screen/slide-rendering/ui';

export interface DifficultQuestionElementProps {
    slideId: number;
    questionModuleType: QuestionModuleType;
    qmv: number;
    questionNumber: string; // e.g.: 1.3.01-007 = caption of slide with id=2181
    guid: string;
}

@Component({
    selector: 'pcp-difficult-question-element',
    templateUrl: './difficult-question-element.component.html',
    styleUrls: ['./difficult-question-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EmmIframeComponent, AsyncPipe]
})
export class DifficultQuestionElementComponent {
    iframeSrc$: Observable<string>;

    @Output() showVideo = new EventEmitter<number>();

    private readonly difficultQuestionElementBaseSrc = inject(DIFFICULT_QUESTION_ELEMENT_BASE_URL);
    private readonly difficultQuestionElementIsMainClient = inject(DIFFICULT_QUESTION_ELEMENT_IS_MAIN_CLIENT);
    private readonly difficultQuestionElementMuteAudio = inject(DIFFICULT_QUESTION_ELEMENT_MUTE_AUDIO);
    private readonly languageCode = inject(DIFFICULT_QUESTION_ELEMENT_LANGUAGE_CODE);
    private readonly enetToken$ = inject(DIFFICULT_QUESTION_ELEMENT_ENET_TOKEN);
    private readonly environmentType = inject(ENVIRONMENT_TYPE);

    @Input() set difficultQuestionElement(
        elementProps: DifficultQuestionElementProps
    ) {
        this.iframeSrc$ = this.enetToken$.pipe(
            distinctUntilChanged(),
            map((enetToken) => {
                if (!isNotNullOrUndefined(enetToken)) {
                    throw 'Unable to render difficultQuestion element: enetToken is undefined';
                }

                let type = this.environmentType === 'FahrTUTOR' ? 'FahrAPP' : 'FahrenLernenMaxDE';
                if (elementProps.questionModuleType === 'vc') {
                    type = 'VogelCheck';
                }

                const questionList = elementProps.questionNumber;
                return `${this.difficultQuestionElementBaseSrc}/${type}?languagekey=${this.languageCode}&questionList=${questionList}&QMV=${elementProps.qmv}&Authorization=${enetToken}&IsMainClient=${this.difficultQuestionElementIsMainClient}&MuteAudio=${this.difficultQuestionElementMuteAudio}&GUID=${elementProps.guid}`;
            }),
            take(1) // url will _not_ update automatically if the token changes
        );
    }

    onMessageFromIframe(message: string) {
        if (message.startsWith('PCP-VIDEO')) {
            const [eventName, videoId] = message.split('|');
            this.showVideo.next(Number(videoId));
        }
    }
}
